import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatDialogTitle} from '@angular/material/dialog';
import {NgIf} from "@angular/common";
import {MatTooltip} from "@angular/material/tooltip";
import {MatRipple} from "@angular/material/core";

@Component({
    selector: 'app-modal-header',
    templateUrl: './modal-header.component.html',
    styleUrls: ['./modal-header.component.scss'],
    imports: [MatDialogTitle, NgIf, MatTooltip, MatRipple]
})
export class ModalHeaderComponent {
  @Input() title: string
  @Input() save: boolean
  @Input() create: boolean
  @Input() send: boolean
  @Input() export: boolean
  @Input() test: boolean
  @Input() confirm: boolean
  @Input() processing: boolean
  @Input() next: boolean
  @Input() refresh: boolean
  @Input() refreshTooltip: string
  @Input() refreshing: boolean
  @Input() share: boolean
  @Input() useTemplate: boolean
  @Output() onClose = new EventEmitter()
  @Output() onSave = new EventEmitter()
  @Output() onSend = new EventEmitter()
  @Output() onExport = new EventEmitter()
  @Output() onTest = new EventEmitter()
  @Output() onConfirm = new EventEmitter()
  @Output() onNext = new EventEmitter()
  @Output() onRefresh = new EventEmitter()
  @Output() onShare = new EventEmitter()
  @Output() onCreate = new EventEmitter()
  @Output() onUseTemplate = new EventEmitter()
}
